import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enCommon from './locales/en/common.json';
import enPages from './locales/en/pages.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { common: enCommon, pages: enPages },
  },
  ns: ['common', 'pages'],
  defaultNS: 'common',
  fallbackNS: ['common', 'pages'],
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  keySeparator: false,
  nsSeparator: false,
  returnNull: false,
});

export default i18n;
